import { render, staticRenderFns } from "./MemoSwiper.vue?vue&type=template&id=0dcf7cbd&scoped=true&"
import script from "./MemoSwiper.vue?vue&type=script&lang=js&"
export * from "./MemoSwiper.vue?vue&type=script&lang=js&"
import style0 from "./MemoSwiper.vue?vue&type=style&index=0&id=0dcf7cbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf7cbd",
  null
  
)

export default component.exports